import React from 'react';
import {
  Dialog, Portal, Paragraph, Button,
} from 'react-native-paper';

// eslint-disable-next-line react/prop-types
function LocationDisclosureDialog({ visible, onAccept, onDecline }) {
  return (
    <Portal>
      <Dialog visible={visible} dismissable={false}>
        <Dialog.Title>Partage de votre position</Dialog.Title>
        <Dialog.Content>
          <Paragraph>
            Pour assurer le suivi de vos trajets en tant que conducteur, KCB a besoin
            d&apos;accéder à votre position GPS, y compris lorsque l&apos;application
            fonctionne en arrière-plan ou est fermée, pendant toute la durée d&apos;un
            trajet en cours.
          </Paragraph>
          <Paragraph style={{ marginTop: 8 }}>
            Cette position est utilisée uniquement pour permettre aux organisateurs et
            aux personnes suivant votre trajet de connaître votre avancée en temps réel.
            Elle n&apos;est plus collectée une fois le trajet terminé. Pour en savoir plus,
            consultez notre politique de confidentialité.
          </Paragraph>
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={onDecline}>Refuser</Button>
          <Button onPress={onAccept}>J&apos;autorise</Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
}

export default LocationDisclosureDialog;
